import { Route } from "react-router-dom";
import SingleAssistant from "@pages/assistants/single-assistant";
import CreateAssistant from "@pages/assistants/create-assistant";

export const assistantRoutes = [
  <Route
    key="single-assistant"
    path="/assistants/new/:type/:id"
    element={<SingleAssistant />}
  />,
  <Route
    key="create-assistant"
    path="/assistants/new/:type"
    element={<CreateAssistant />}
  />,
];
